import styles from "./styles";

export const planBgColor = ["white", "#F4FBF3", "#6FBB98", styles.blue]